let lastScrollY = window.scrollY;

document.addEventListener('scroll', _.throttle(function(e) {
  const MIN_CHANGE = 100;
  let currentScrollY = window.scrollY;

  if (currentScrollY > lastScrollY) {
    if (currentScrollY - lastScrollY > MIN_CHANGE) {
      document.getElementsByClassName('header')[0].classList.add('header--scroll-down')
      lastScrollY = currentScrollY;
    }
  } else {
    if (lastScrollY - currentScrollY > MIN_CHANGE) {
      document.getElementsByClassName('header')[0].classList.remove('header--scroll-down')
      lastScrollY = currentScrollY;
    }
  }
}, 100));
